import React from "react";
import { Footer } from "../components";

export function FooterContainer({ children }) {
  return <Footer>{children}</Footer>;
}
